<template>
  <div class="account-chose">
    <pageHeader title="选择出售账号" />

    <div class="account-container">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="onLoad"
        :immediate-check="false"
        v-if="accountList.length"
      >
        <div class="account-box">
          <div
            class="account-item"
            v-for="(item, i) in accountList"
            :key="i"
          >
            <div class="account-info">
              <img :src="item.showLogoUrl" alt="" />
              <div class="account-amount">
                <h1>{{ item.gameName }}</h1>
                <span class="account-desc"
                  >游戏账号：{{ item.gameAccountNo }}</span
                >

                <span class="total-sall">平台：{{ item.platName }}</span>
              </div>
            </div>

            <span class="sall-price" @click="goToCellAccount(item)">出售</span>
          </div>
        </div>
      </van-list>
      <div class="empty-account" v-else>
        <img src="@/assets/images/ic_default_three.png" alt="" />
        <span>暂无可出售账号</span>
      </div>
    </div>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
export default {
  components: {
    pageHeader,
  },
  computed: {
    ...mapGetters(["uuid"]),
    finishedText() {
      if (this.accountList.length) {
        return "暂无更多数据";
      } else {
        return "";
      }
    },
  },
  data() {
    return {
      loading: false,
      finished: false,
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      accountList: [],
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    async onLoad() {
      this.loading = true;
      const { data, totalCount } = await this.transGameAccountList();
      this.accountList = [...this.accountList, ...data];
      this.totalCount = totalCount;
      this.totalPage = Math.ceil(this.totalCount / this.pageSize);
      // 数据全部加载完成
      if (this.currentPage >= this.totalPage) {
        this.finished = true;
      }
      this.currentPage += 1;

      this.loading = false;
    },

    /**
     * 查询可出售账号列表
     */
    async transGameAccountList() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/accounttx/accountTx/transGameAccountList.htm",
          "post",
          {
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            searchParams: JSON.stringify({
              uuid: this.uuid,
              gameName: this.gameName,
            }),
          }
        );
        return {
          data: data,
          totalCount: totalCount,
        };
      } catch (err) {
        this.$toast(err.message);
      }
    },

    goToCellAccount(info) {
        const { gameName, id, platName, platUrl, gameAccountNo } = info
        this.$router.push({ path: '/cellAccount', query: {
            gameName, id, platName, platUrl, gameAccountNo
        } })
    }
  },
};
</script>

<style lang="scss">
.account-chose {
  min-height: 100vh;
  background: #f8f8f8;
  .account-container {
    .empty-account {
      text-align: center;
      height: calc(100vh - 386px);
      margin-top: 300px;
      img {
        width: 260px;
        height: 160px;
        margin-bottom: 20px;
      }
      span {
        display: block;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #7f7f7f;
        line-height: 33px;
      }
    }
    .account-box {
      padding: 15px;
      background: #f8f8f8;
      .account-item {
        background: #fff;
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 15px;

        &:last-child {
          margin-bottom: 0;
        }

        .account-info {
          display: flex;
          align-items: flex-start;
          img {
            width: 132px;
            height: 132px;
            margin-right: 20px;
          }

          .account-amount {
            h1 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 28px;
              color: #191919;
              margin-bottom: 4px;
              line-height: 40px;
              max-width: 520px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .account-desc {
              display: block;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 26px;
              color: #7f7f7f;
              line-height: 37px;
              margin-bottom: 14px;
              max-width: 520px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .total-sall {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 26px;
              color: #7f7f7f;
              line-height: 37px;
            }
          }
        }
        .sall-price {
          //   position: absolute;
          width: 120px;
          height: 60px;
          background: #ff7a3e;
          border-radius: 30px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 28px;
          color: #ffffff;
          line-height: 60px;
          text-align: center;
          //   right: 45px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/accountChose/index.vue